import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const UserWorker = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='UserWorker' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M3,6 L21,6 L3,6 Z M10,2 L10,4 M14,2 L14,4 M16,12 C18.3736719,13.1826446 20,15.6506255 20,19 L20,23 L4,23 L4,19 C4,15.6457258 5.6310898,13.1754259 8,12 M12,16.5 L12,23 M12,13 C15.3137085,13 18,10.3137085 18,7 C18,3.6862915 15.3137085,1 12,1 C8.6862915,1 6,3.6862915 6,7 C6,10.3137085 8.6862915,13 12,13 Z M8,12 C8,14.209139 9.790861,16 12,16 L12,16 C14.209139,16 16,14.209139 16,12' />
  </StyledIcon>
);
